import { c as _c } from "react/compiler-runtime";
import { LabelWithHelp } from "@components/common/label-with-help";
import { Autocomplete, NO_TRANSLATE_CLASS } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";
/** Placeholder for workspaces where only email addresses can be entered. */
export const EMAILS_ONLY_PLACEHOLDER = "Enter email addresses (Separated by comma, semicolon, or space)";

/**
 * Renders autocomplete component of flat-ui for members selection. It can be used to select multiple members or emails.
 */
export function MembersAutocomplete(t0) {
  const $ = _c(16);
  const {
    label,
    isValid,
    options,
    helperText,
    isRequired,
    hasAutoFocus,
    onInputChange,
    selectedOptions,
    handleMemberSelect,
    placeHolder,
    labelHelp: t1
  } = t0;
  const labelHelp = t1 === undefined ? "To add multiple members/emails, simply separate them by pressing enter, semicolon, or comma." : t1;
  const {
    canUseTeams
  } = useHasUserValidFeatureCompanyLevel();
  const defaultPlaceHolder = canUseTeams ? `Select ${TEAM_DISPLAY_NAME} or ${EMAILS_ONLY_PLACEHOLDER}` : EMAILS_ONLY_PLACEHOLDER;
  let t2;
  if ($[0] !== isRequired || $[1] !== label || $[2] !== labelHelp) {
    t2 = label && <LabelWithHelp isRequired={isRequired} title={label} help={labelHelp} />;
    $[0] = isRequired;
    $[1] = label;
    $[2] = labelHelp;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = placeHolder ?? defaultPlaceHolder;
  let t4;
  if ($[4] !== handleMemberSelect || $[5] !== hasAutoFocus || $[6] !== helperText || $[7] !== isValid || $[8] !== onInputChange || $[9] !== options || $[10] !== selectedOptions || $[11] !== t3) {
    t4 = <Stack className={NO_TRANSLATE_CLASS}><Autocomplete allowDuplicateOnPaste={true} isValid={isValid} options={options} hasAutoFocus={hasAutoFocus} selectedOptions={selectedOptions} autocompleteHelperText={helperText} handleChange={handleMemberSelect} onInputChange={onInputChange} placeHolder={t3} /></Stack>;
    $[4] = handleMemberSelect;
    $[5] = hasAutoFocus;
    $[6] = helperText;
    $[7] = isValid;
    $[8] = onInputChange;
    $[9] = options;
    $[10] = selectedOptions;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}